import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../../utils/helper';

export const timerPageClasses = generateClasses('TimerPage', ['content', 'timerCard', 'timerCardCenter']);

export const Root = styled((props: StackProps) => <Stack gap={4} px={4} py={2} height="100%" {...props} />)(
  ({ theme }) => ({
    [`& .${timerPageClasses.content}`]: {
      flex: 1,
    },
  })
);

export const Content = styled('div')(({ theme }) => ({
  position: 'relative',

  [`& .${timerPageClasses.timerCard}`]: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    bottom: theme.spacing(2),
    width: 300,

    [`&.${timerPageClasses.timerCardCenter}`]: {
      right: 'unset',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
}));
